<template>
  <div class="sb_add-background">
    <Wrapper>
      <Title>Voeg afbeelding toe</Title>
      <Subtitle>Of laat je inspireren door één van onze designs.</Subtitle>
      <Upload
        class="sb_add-background_upload"
        @error="$emit('errorModal', { error: $event, type: 'afbeelding' })"
        @change="selectFile"
        :loading.sync="loader"
        :disabled="loader && !loader.includes('background')"
      >
        <span v-if="activeBackground !== customBackgroundId">Upload afbeelding</span>
        <span v-else>Wijzig afbeelding</span>
      </Upload>
    </Wrapper>
    <hr />
    <Gallery
      :loading.sync="loader"
      :images.sync="backgroundList"
      type="background"
      @addItem="$emit('addBackground', $event)"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Gallery from './partials/Gallery.vue';
import Upload from './partials/Upload.vue';

export default {
  data() {
    return {
      file: null,
      loadBackground: null,
      backgroundList: [],
      customBackgroundId: null,
    };
  },
  props: {
    loading: {
      type: [Boolean, String],
      default: false,
    },
  },
  components: {
    Gallery,
    Upload,
  },
  watch: {
    loading(val) {
      if (val) {
        if (!this.loadBackground) {
          this.loadBackground = this.backgroundList.find((bg) => bg.id === val);
        }
        if (this.loadBackground) {
          this.$set(this.loadBackground, 'loading', true);
        }
      } else {
        if (!this.loadBackground) {
          return;
        }
        this.$set(this.loadBackground, 'loading', false);
        this.loadBackground = null;
      }
    },
  },
  methods: {
    ...mapMutations('design', ['setActiveBackground']),
    async selectFile(e) {
      this.file = e.target.files[0];
      if (!this.file) {
        this.$emit('errorModal', { error: 'generic', type: 'afbeelding' });
        e.preventDefault();
        return;
      }

      this.loadBackground = {
        src: this.file,
        id: this.customBackgroundId,
      };

      this.$emit('addBackground', this.loadBackground);
    },
    setBackgrounds() {
      // this.backgroundList = Array(5)
      //   .fill(0)
      //   .map((val, index) => {
      //     return {
      //       image: require(`@/assets/images/image-(${index + 1}).jpg`),
      //       thumbnail: require(`@/assets/images/image-(${index + 1})_thumbnail.jpg`),
      //       id: `background-${index}`,
      //     };
      //   });
      this.backgroundList = this.backgrounds;
    },
  },
  created() {
    this.setBackgrounds();
    this.customBackgroundId = window.$store.customBackgroundId || 'Zelf gekozen afbeelding';
  },
  computed: {
    ...mapState('canvas', ['manager']),
    ...mapState('backgrounds', ['backgrounds']),
    ...mapState('design', {
      activeBackground: (state) => {
        return state.background;
      },
    }),
    loader: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit('update:loading', val);
      },
    },
  },
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_add-background {
    &_upload {
      margin-top: 1rem;
    }
  }
}
</style>
